import React from 'react';

import { IonIcon, IonModal, IonHeader, IonToolbar, IonButtons, IonButton, IonTitle, IonContent, IonSpinner, IonRow, IonText } from '@ionic/react';
import { closeCircle } from 'ionicons/icons';

class SignModal extends React.Component<any, any> {
  handleCloseModal = () => {
    this.props.closeModal();
  }

  render() {
    const { props } = this;

    return (
      <IonModal isOpen={props.showModal}>
        <IonHeader color="primary" className="app-header">
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonButton onClick={this.handleCloseModal}><IonIcon icon={closeCircle} /></IonButton>
            </IonButtons>
            <IonTitle>Signera kvalitetsdokument</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent className="ion-padding ion-text-center">
          <IonRow class="ion-justify-content-center ion-align-items-center">
            <IonText className="login-message ion-text-center">
              {props.isLoading && (
                <div className="ion-padding">
                  <IonSpinner name="crescent" />
                </div>
              )}
              <p>{props.message}</p>
            </IonText>
          </IonRow>
        </IonContent>
      </IonModal>
    );
  }
};

export default SignModal;
